<template>
  <div class="flex items-center justify-center h-full w-full py-8 lg:py-16">
    <slot></slot>
  </div>
</template>
